<template>
    <div :class="[
        'input-text',
        { 'is-error': isError }
    ]">
        <input 
            v-model="inputValue" 
            @input="onInput"
        />
    </div>
</template>

<script>
import ValidateMixin from '@/mixins/ValidateMixin'

export default {
    mixins: [
        ValidateMixin
    ],

    props: {
        value: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            inputValue: this.value
        }
    },

    computed: {
        validatedValue() {
            return this.inputValue
        }
    },

    methods: {
        onInput() {
            this.$emit('input', this.inputValue)

            this.isError = false
        },

        getValidationConstraints() {
            return [
                this.validateAgainstRequired()
            ]
        }
    }
}
</script>

<style lang="scss">
.input-text {
    @include input-simple();

    input {
        @include size(100%, 38px);
        border-color: $color-border;
        text-align: left;
    }
}
</style>
